import { render, staticRenderFns } from "./flugverfuegbarkeits-query.vue?vue&type=template&id=5873c554"
import script from "./flugverfuegbarkeits-query.vue?vue&type=script&lang=js"
export * from "./flugverfuegbarkeits-query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports